// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment';
import { CDT, EDT } from '../constants/common';

export function mapFromOrderToOrderCSV(order) {
  const {
    startDateTime,
    id,
    customer,
    activity,
    discount,
    orderId,
    lineItems,
    bookingOptions,
    partyName,
    partyId,
    partySize,
    created,
    updated,
    activityId,
  } = order;

  const requestedStartDate = startDateTime
    ? moment(startDateTime).tz(CDT).format('MM/DD/YY')
    : '';
  const requestedStartTime = startDateTime
    ? moment(startDateTime).tz(CDT).format('hh:mm A')
    : '';

  const customerEmail = customer?.memberEmail || '';
  const customerName = customer?.memberName || '';
  const customerPhone = customer?.memberPhone || '';

  const fulfillmentDate = moment(updated).tz(CDT).format('MM/DD/YY hh:mm A');
  const orderPlacedDate = `${moment(created)
    .tz(EDT)
    .format('YYYY-MM-DD hh:mm a')} ${moment(created).tz(EDT).zoneName()}`;

  const vendorId = activity?.vendorId || '';
  const vendorName = activity?.vendorName || '';
  const activityName = activity?.title || '';
  const activityBookingOptions = activity?.bookingOptions || [];

  const discountCode = discount?.title || '';
  const discountAmount = discount?.amount || '';

  const bookingOptionTitles = activityBookingOptions
    .filter(activityOption =>
      bookingOptions.some(option => option.id === activityOption.id)
    )
    .map(option => option.title)
    .join(' ,');

  const quantity = lineItems?.length || '';

  return {
    ...order,
    requestedStartDate,
    requestedStartTime,
    shopifyOrderId: orderId > 0 ? orderId : id,
    customerEmail,
    customerName,
    customerPhone,
    fulfillmentDate,
    vendorId,
    vendorName,
    discountCode,
    discountAmount,
    activityName,
    orderId,
    quantity,
    bookingOptionTitles,
    partySize,
    partyId,
    partyName,
    orderPlacedDate,
    activityId,
  };
}
